module.exports = __webpack_public_path__ + "static/img/jiditit.1876596d.png";